module.exports = __webpack_public_path__ + "static/media/bam.9919202b.png";